import { useIsAgencyPerson } from './useIsAgencyPerson';

/**
 * Favorites are for agency people (Jesse, 2026-10-07: "hide favorites from
 * non-agency people... it's not really useful to them"). Clients get no ★ on
 * the app bar, no stars on project rows or headers, and no Pinned band.
 */
export function useCanFavorite(): boolean {
  return useIsAgencyPerson();
}
